import React, { createContext, useContext } from "react";

import { trackEvent, trackMPPageView } from "./mixpanel";
import { MIXPANEL_ERROR_TYPE, MIXPANEL_INFO_TYPE } from "./constant";

// mixpanel logger
export const mixpanelLogger = (isError, event, meta_data = {}) => {
  trackEvent(event, {
    type: isError ? MIXPANEL_ERROR_TYPE : MIXPANEL_INFO_TYPE,
    ...meta_data
  });
};

const mixpanelPageViewLogger = (pageName) => {
  trackMPPageView(pageName);
};

// all type of logger
const loggers = {
  mixpanel: {
    log: mixpanelLogger,
    pageView: mixpanelPageViewLogger
  }
};

export const LoggerContext = createContext(loggers);

export const LoggerProvider = ({ children }) => {
  return (
    <LoggerContext.Provider value={loggers}>{children}</LoggerContext.Provider>
  );
};

export const useLogger = () => useContext(LoggerContext);
